module.exports = [{
      plugin: require('/zeit/e9eddc3/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
